import retention from "@/api/retention";

const state = {
  adhocInvoiceData: {},
  isFetchAdhocInvoiceDataLoading: false,
  isFetchAdhocInvoiceDataError: false,
  isFetchAdhocInvoiceDataErrorResponse: null,

  isUpdateAdhocInvoiceDataLoading: false,
  isUpdateAdhocInvoiceDataError: false,
  isUpdateAdhocInvoiceDataErrorResponse: null,

  isDownloadAdhocInvoiceDataLoading: false,
  isDownloadAdhocInvoiceDataError: false,
  isDownloadAdhocInvoiceDataErrorResponse: null,
};

const mutations = {
  FETCH_ADHOC_INVOICE_BEGIN(state) {
    state.isFetchAdhocInvoiceDataLoading = true;
    state.isFetchAdhocInvoiceDataError = false;
    state.isFetchAdhocInvoiceDataErrorResponse = null;
  },
  FETCH_ADHOC_INVOICE_SUCCESS(state, payload) {
    state.adhocInvoiceData = payload;
    state.isFetchAdhocInvoiceDataLoading = false;
  },
  FETCH_ADHOC_INVOICE_ERROR(state, err) {
    state.isFetchAdhocInvoiceDataLoading = false;
    state.isFetchAdhocInvoiceDataError = true;
    state.isFetchAdhocInvoiceDataErrorResponse = err;
  },

  UPDATE_ADHOC_INVOICE_BEGIN(state) {
    state.isUpdateAdhocInvoiceDataLoading = true;
    state.isUpdateAdhocInvoiceDataError = false;
    state.isUpdateAdhocInvoiceDataErrorResponse = null;
  },
  UPDATE_ADHOC_INVOICE_SUCCESS(state, payload) {
    state.adhocInvoiceData = payload;
    state.isUpdateAdhocInvoiceDataLoading = false;
  },
  UPDATE_ADHOC_INVOICE_ERROR(state, err) {
    state.isUpdateAdhocInvoiceDataLoading = false;
    state.isUpdateAdhocInvoiceDataError = true;
    state.isUpdateAdhocInvoiceDataErrorResponse = err;
  },

  DOWNLOAD_ADHOC_INVOICE_BEGIN(state) {
    state.isDownloadAdhocInvoiceDataLoading = true;
    state.isDownloadAdhocInvoiceDataError = false;
    state.isDownloadAdhocInvoiceDataErrorResponse = null;
  },
  DOWNLOAD_ADHOC_INVOICE_SUCCESS(state) {
    state.isDownloadAdhocInvoiceDataLoading = false;
  },
  DOWNLOAD_ADHOC_INVOICE_ERROR(state, err) {
    state.isDownloadAdhocInvoiceDataLoading = false;
    state.isDownloadAdhocInvoiceDataError = true;
    state.isDownloadAdhocInvoiceDataErrorResponse = err;
  }
};

const actions = {
  async fetchAdhocInvoiceData({ commit }, leadId) {
    commit("FETCH_ADHOC_INVOICE_BEGIN");
    try { 
      const response = await retention.fetchAdhocInvoiceData(leadId);
      commit("FETCH_ADHOC_INVOICE_SUCCESS", response.data);
    } catch(err) {
      commit("FETCH_ADHOC_INVOICE_ERROR", err.response.data);
    }
  },

  async updateAdhocInvoiceData({ commit, dispatch }, { leadId, payload }) {
    commit("UPDATE_ADHOC_INVOICE_BEGIN");
    try { 
      const response = await retention.updateAdhocInvoiceData(leadId, payload);
      commit("UPDATE_ADHOC_INVOICE_SUCCESS", response.data);
      dispatch("alerts/setAlert", { type: "success", message: "Invoice sent successfully" }, { root: true });
    } catch(err) {
      commit("UPDATE_ADHOC_INVOICE_ERROR", err.response.data);
      dispatch("alerts/setAlert", { type: "error", message: err.response.data.message }, { root: true });
    }
  },

  async downloadAdhocInvoice({ commit }, invoiceId) {
    commit("DOWNLOAD_ADHOC_INVOICE_BEGIN");
    try { 
      const response = await retention.downloadAdhocInvoice(invoiceId);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      let date = new Date();
      link.download = `adhoc-invoice-${date.toISOString()}.pdf`;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      commit("DOWNLOAD_ADHOC_INVOICE_SUCCESS");
    } catch(err) {
      commit("DOWNLOAD_ADHOC_INVOICE_ERROR", err.response.data);
      dispatch("alerts/setAlert", { type: "error", message: err.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getAdhocInvoiceData: state => state.adhocInvoiceData,
  getIsFetchAdhocInvoiceDataLoading: state => state.isFetchAdhocInvoiceDataLoading,
  getIsFetchAdhocInvoiceDataError: state => state.isFetchAdhocInvoiceDataError,
  getIsFetchAdhocInvoiceDataErrorResponse: state => state.isFetchAdhocInvoiceDataErrorResponse,

  getIsUpdateAdhocInvoiceDataLoading: state => state.isUpdateAdhocInvoiceDataLoading,
  getIsUpdateAdhocInvoiceDataError: state => state.isUpdateAdhocInvoiceDataError,
  getIsUpdateAdhocInvoiceDataErrorResponse: state => state.isUpdateAdhocInvoiceDataErrorResponse,

  getIsDownloadAdhocInvoiceDataLoading: state => state.isUpdateAdhocInvoiceDataLoading,
  getIsDownloadAdhocInvoiceDataError: state => state.isUpdateAdhocInvoiceDataError,
  getIsDownloadAdhocInvoiceDataErrorResponse: state => state.isUpdateAdhocInvoiceDataErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
